import cx from 'classnames'
import { useTranslation } from 'react-i18next'

import { setLanguageCookies } from 'lib/cookie'
import { LANGUAGE_MAPPER } from 'lib/i18n'

import Menu from 'components/Menu'

import './style.scss'

const LanguageDropdown = ({ isLandingPage }: { isLandingPage?: boolean }) => {
  const { i18n } = useTranslation()
  const currentLanguage = i18n.language

  const changeLanguage = async (lang: string) => {
    setLanguageCookies(lang)

    window.setTimeout(() => {
      window.location.reload()
    }, 100)
  }

  const options = Object.keys(LANGUAGE_MAPPER)
    .filter((lang) => lang !== currentLanguage)
    .map((lang) => ({
      title: LANGUAGE_MAPPER[lang],
      onClick: () => changeLanguage(lang),
    }))

  return (
    <div className="LanguageDropdown">
      <Menu
        handlerElement={({ onClick }) => (
          <a onClick={() => onClick()} className="LanguageDropdown__handler">
            <svg
              width="14"
              height="15"
              viewBox="0 0 14 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.99683 0.833252C3.3135 0.833252 0.333496 3.81659 0.333496 7.49992C0.333496 11.1833 3.3135 14.1666 6.99683 14.1666C10.6802 14.1666 13.6668 11.1833 13.6668 7.49992C13.6668 3.81659 10.6802 0.833252 6.99683 0.833252ZM11.6135 4.83325H9.64683C9.43016 3.99992 9.12683 3.19992 8.72683 2.45992C9.9535 2.87992 10.9735 3.72992 11.6135 4.83325ZM7.00016 2.18992C7.55683 2.98992 7.99016 3.87992 8.2735 4.83325H5.72683C6.01016 3.87992 6.4435 2.98992 7.00016 2.18992ZM1.84016 8.83325C1.73016 8.40659 1.66683 7.95992 1.66683 7.49992C1.66683 7.03992 1.73016 6.59325 1.84016 6.16659H4.09016C4.03683 6.60325 4.00016 7.04659 4.00016 7.49992C4.00016 7.95325 4.03683 8.39659 4.0935 8.83325H1.84016ZM2.3835 10.1666H4.35016C4.56683 10.9999 4.87016 11.7999 5.27016 12.5433C4.0435 12.1233 3.0235 11.2699 2.3835 10.1666ZM4.35016 4.83325H2.3835C3.0235 3.72992 4.0435 2.87659 5.27016 2.45659C4.87016 3.19992 4.56683 3.99992 4.35016 4.83325ZM7.00016 12.8099C6.44683 12.0099 6.0135 11.1199 5.72683 10.1666H8.2735C7.98683 11.1199 7.5535 12.0099 7.00016 12.8099ZM8.56016 8.83325H5.44016C5.37683 8.39659 5.3335 7.95325 5.3335 7.49992C5.3335 7.04659 5.37683 6.60325 5.44016 6.16659H8.56016C8.6235 6.60325 8.66683 7.04659 8.66683 7.49992C8.66683 7.95325 8.6235 8.39659 8.56016 8.83325ZM8.73016 12.5399C9.13016 11.7966 9.4335 10.9999 9.65016 10.1666H11.6168C10.9735 11.2699 9.9535 12.1199 8.73016 12.5399ZM9.90683 8.83325C9.96016 8.39659 10.0002 7.95325 10.0002 7.49992C10.0002 7.04659 9.9635 6.60325 9.90683 6.16659H12.1568C12.2668 6.59325 12.3335 7.03992 12.3335 7.49992C12.3335 7.95992 12.2702 8.40659 12.1568 8.83325H9.90683Z"
                fill={isLandingPage ? '#ffffff' : 'black'}
                fillOpacity="0.54"
              />
            </svg>

            <p
              className={cx('LanguageDropdown__handler__p', {
                'LanguageDropdown__handler__p--white': isLandingPage,
              })}
            >
              {LANGUAGE_MAPPER[currentLanguage]}
            </p>

            <span className="Menu__handle Menu__handle--dropdown" />
          </a>
        )}
        options={options}
      />
    </div>
  )
}

export default LanguageDropdown
